/* eslint-disable react/no-unescaped-entities */
import { useState } from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { useSiteImage } from '@/contexts/SiteImagesContext';

const WP = '/uploads/sito';

// Note: Images served from local Media Library

const EVENTS = [
  { date: 'Ottobre 2024', year: '2024', title: 'Il Canto del Corpo', image: `${WP}/5a5c0047518d_INVITO-IL-CANTO-DEL-CORPO-300x300.jpg` },
  { date: 'Novembre 2022', year: '2022', title: 'Melina', image: `${WP}/773b181db15c_INVITO-MELINA-300x300.jpg` },
  { date: 'Novembre 2019', year: '2019', title: 'Presenze Invisibili', image: `${WP}/d214cd921f16_Presenze-Invisibili-1-1024x744.jpg` },
  { date: 'Ottobre 2018', year: '2018', title: "L'Abbraccio che Libera", image: `${WP}/8982a18fb9fb_abbraccio-che-libera-1-1024x682.jpg` },
  { date: 'Maggio 2018', year: '2018', title: 'Salute e Cuore', image: `${WP}/a1931dc4dfe5_immagine-salute-cuore-1-300x300.jpg` },
  { date: 'Aprile 2018', year: '2018', title: 'Menopausa e Salute', image: `${WP}/a9b1d4d31f15_immagine-menopausa-1-150x150.jpg` },
  { date: 'Marzo 2018', year: '2018', title: "Il Gusto dell'Arte", image: `${WP}/78b4f3020440_Il-Gusto-dellArte-1-300x300.jpg` },
  { date: 'Febbraio 2018', year: '2018', title: 'Conferenza Ghelfi', image: `${WP}/91f425dc5f6d_conferenza-Ghelfi-1-1024x636.jpg` },
  { date: 'Gennaio 2018', year: '2018', title: 'Eco Office', image: `${WP}/b4a8b983bdfb_Eco-office_immagine-1-300x297.jpg` },
  { date: 'Settembre 2017', year: '2017', title: "L'Impronta dell'Anima", image: `${WP}/31296b23c3ab_limpronta-dellanima-1-1024x683.jpg` },
  { date: 'Giugno 2017', year: '2017', title: 'Book Box', image: `${WP}/cf33290c3088_Book-Box-1-1024x749.jpg` },
  { date: 'Maggio 2017', year: '2017', title: 'Mostra', image: `${WP}/8ca313ced8e8_Logo-mostra-1.jpg` },
  { date: 'Aprile 2017', year: '2017', title: 'Arte e Salute', image: `${WP}/f10de0375f68_arte-salute-boscovich-1-1024x777.jpg` },
  { date: 'Maggio 2016', year: '2016', title: 'Culture & Salute', image: `${WP}/880209a3258c_hbz-the-list-culture-salma-hayek-01-1-784x1024.jpg` },
  { date: 'Maggio 2016', year: '2016', title: "Sprigioniamo l'Arte", image: `${WP}/8b894501fcd2_Immagine-Mostra-1-796x1024.jpg` },
  { date: 'Novembre 2015', year: '2015', title: 'Van Gogh', image: `${WP}/0ec4d41efe48_Van-Gogh-1-150x150.jpg` },
  { date: 'Novembre 2015', year: '2015', title: 'A Tutto Campo...', image: `${WP}/0bee0fc3f1ca_A-tutto-campo...-1-1015x1024.jpg` },
  { date: 'Ottobre 2015', year: '2015', title: 'Rimedi Esterni', image: `${WP}/a375f01669f4_Rimedi-Esterni-5-corso_1-1-1024x683.jpg` },
  { date: 'Ottobre 2015', year: '2015', title: 'Corso per Ostetriche', image: `${WP}/258ff01faefd_Corso-per-ostetriche-1-1024x650.jpg` },
  { date: 'Settembre 2015', year: '2015', title: 'Venite, è Pronto in Tavola', image: `${WP}/4e6f7f7ffacb_Venite-e-pronto-in-tavola-1024x683.jpg` },
  { date: 'Maggio 2015', year: '2015', title: 'Una Stanza Tutta per Sé', image: `${WP}/35047ca0ba29_Locandina-1-300x273.jpg` },
  { date: 'Marzo 2015', year: '2015', title: "Tutti Pazzi per l'Arte", image: `${WP}/186116e58b5b_Ivan_imma-CS-1-768x528.jpg` },
  { date: 'Novembre 2014', year: '2014', title: 'An Images Project', image: `${WP}/a4c5bcb2b7c9_vittorio_matteo_corcos_-_dreams_-_1896_alta-862x1024-1-768x912.jpg` },
  { date: 'Maggio 2014', year: '2014', title: 'Botero - La Famiglia', image: `${WP}/7b739e6cd951_BOTERO-La-famiglia-768x1024-1-225x300.jpg` },
  { date: 'Gennaio 2014', year: '2014', title: 'Ichiro Tsuruta', image: `${WP}/850a0a1c98b3_Ichiro-Tsuruta8-849x1024-1-249x300.jpg` },
  { date: 'Dicembre 2013', year: '2013', title: 'Mai Più Guerre', image: `${WP}/98d32f25b4f0_mai-piu-guerre-1-768x389.jpg` },
  { date: 'Novembre 2013', year: '2013', title: 'Susanna e i Vecchioni', image: `${WP}/0e7ef6e7aa48_Susanna_and_the_Elders-1609-1024x888-1-150x150.jpg` },
  { date: 'Ottobre 2013', year: '2013', title: 'Bellini', image: `${WP}/3fb8e1c329f5_Bellini2-1-150x150.jpg` },
  { date: 'Settembre 2013', year: '2013', title: 'The Hidden Courtyard', image: `${WP}/a1fcb3208eef_The-Hidden-Courtyard-series-22C-2013-1.jpg` },
  { date: 'Maggio 2013', year: '2013', title: 'Modigliani', image: `${WP}/b424466eaedd_Modigliani-1024x641-1.jpg` },
  { date: 'Maggio 2013', year: '2013', title: 'Lady with Fan - Klimt', image: `${WP}/058fd81ea3ca_Lady-with-Fan-Gustav-Klimt1-1-300x300.jpg` },
  { date: 'Marzo 2013', year: '2013', title: 'Matisse', image: `${WP}/447f721c742b_Matisse1-1-150x150.jpg` },
  { date: 'Gennaio 2013', year: '2013', title: 'The Hidden Courtyard Series', image: `${WP}/9db7259f0b02_The-Hidden-Courtyard-series-22C-2013-1-300x181.jpg` },
  { date: 'Ottobre 2012', year: '2012', title: 'Morelli', image: `${WP}/bbc4af903e94_Morelli-1-300x182.jpg` },
  { date: 'Settembre 2012', year: '2012', title: 'Made in Italy', image: `${WP}/bf32ea8f2c01_Made-in-Italy_Installation-view-91-1-150x150.jpg` },
  { date: 'Gennaio 2012', year: '2012', title: 'Inaugurazione', image: `${WP}/a2940a7e153e_corni-1024x392-1-768x294.jpg` },
];

const YEARS = [...new Set(EVENTS.map(e => e.year))].sort((a, b) => b - a);

export default function OperazioneCultura() {
  const [filterYear, setFilterYear] = useState('');
  const caterinaImg = useSiteImage('caterina_corni');
  const placeholderF = useSiteImage('placeholder_female');
  
  const filteredEvents = filterYear ? EVENTS.filter(e => e.year === filterYear) : EVENTS;

  return (
    <div>
      {/* Hero */}
      <section className="hero-wash py-14 sm:py-20">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1F2A37] mb-4" style={{fontFamily:'Space Grotesk'}}>Operazione Cultura</h1>
          <p className="text-lg text-muted-foreground max-w-3xl">Le nostre iniziative tra Arte e Salute</p>
        </div>
      </section>

      {/* Intro + Caterina */}
      <section className="py-14 sm:py-20">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-3 gap-10 items-start">
            <div className="lg:col-span-2">
              <h2 className="text-2xl font-bold text-[#1F2A37] mb-6" style={{fontFamily:'Space Grotesk'}}>Arte come Terapia</h2>
              <div className="space-y-4 text-muted-foreground leading-relaxed">
                <p>
                  Tutto ciò che ci alimenta spiritualmente migliora anche il nostro fisico. Uno studio pubblicato sull'<em>American Journal of Public Health</em> ha evidenziato che impegnarsi in attività creative può contribuire alla riduzione dello stress e può essere uno strumento per alleviare il peso dovuto alle malattie croniche.
                </p>
                <p>
                  Attraverso la creatività e l'immaginazione troviamo la nostra identità e la riserva interiore che stimola la guarigione. Lo Studio Medico Boscovich intende veicolare questa linea di pensiero divulgando la cultura fuori dagli ambiti tradizionali, rendendola così maggiormente fruibile, accessibile e facendo in modo che l'Arte diventi una vera e propria terapia.
                </p>
              </div>
            </div>
            
            {/* Caterina Corni card */}
            <Card className="overflow-hidden">
              <div className="aspect-square overflow-hidden bg-[hsl(var(--muted))]">
                <img
                  src={caterinaImg || placeholderF}
                  alt="Caterina Corni"
                  className="w-full h-full object-cover"
                  onError={e => { e.target.src = '/images/placeholder-f.jpg'; }}
                />
              </div>
              <CardContent className="p-4">
                <h3 className="font-bold text-[#1F2A37] mb-1" style={{fontFamily:'Space Grotesk'}}>Caterina Corni</h3>
                <Badge className="mb-3 bg-[hsl(var(--accent))] text-[hsl(var(--accent-foreground))] hover:bg-[hsl(var(--accent))]">Responsabile Operazione Cultura</Badge>
                <p className="text-xs text-muted-foreground leading-relaxed">
                  Curatrice e critica d'arte moderna e contemporanea. Ha organizzato numerose mostre in Italia e all'estero. Prof. Associato presso la Symbiosis University di Pune (India), membro dell'Assemblea degli Afferenti del Centre for Cultural Heritage Studies, Università dell'Insubria.
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* Bio estesa */}
      <section className="section-mist py-10 sm:py-14">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <details className="group">
            <summary className="cursor-pointer text-[#238A92] font-medium text-sm hover:underline list-none flex items-center gap-2">
              <span className="group-open:rotate-90 transition-transform">▶</span>
              Leggi la biografia completa di Caterina Corni
            </summary>
            <p className="mt-4 text-sm text-muted-foreground leading-relaxed max-w-4xl">
              È curatrice e critica d'arte moderna e contemporanea. Ha organizzato numerose mostre in Italia e all'estero e collaborato con diverse testate specializzate nel settore tra cui Take on Art e FlashArt. Attualmente lavora come consulente d'arte per il Governo Indiano, collezionisti privati, gallerie, musei e aziende tra cui TATA Sons e UBI Banca. Tra le principali mostre: "Jamini Roy. La Collezione Kumar" Museo delle Culture, Lugano; "Dr. Babasaheb Ambedkar Memorial", Londra; "Art Bahrain Across Borders", Bahrain (Curatrice dello stand Italia); "Sprigioniamo l'Arte. Creatività al femminile nel carcere di San Vittore" Associazione Boscovich Arte e Salute, Milano; "L'impronta dell'anima. Nairò e le sue opere", Casa delle Arti – Spazio Alda Marini, Milano; "Found Photos in Detroit", Clark House gallery, Focus Festival, Mumbai; "MADE IN ITALY", Sakshi Gallery, Mumbai; "Michelangelo Pistoletto. Notte Love Difference", Dream Factory gallery, Milano; "Majhi International Art Residency", Venezia-Dhaka.
            </p>
          </details>
        </div>
      </section>

      {/* Portfolio / Eventi */}
      <section className="py-14 sm:py-20">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-8">
            <div>
              <h2 className="text-2xl font-bold text-[#1F2A37] mb-1" style={{fontFamily:'Space Grotesk'}}>Le Nostre Iniziative</h2>
              <p className="text-muted-foreground text-sm">{filteredEvents.length} eventi dal 2012 ad oggi</p>
            </div>
            <div className="flex flex-wrap gap-2">
              <Button size="sm" variant={!filterYear ? 'default' : 'outline'} onClick={() => setFilterYear('')} className={!filterYear ? 'bg-[#238A92] text-white' : ''}>
                Tutti
              </Button>
              {YEARS.map(y => (
                <Button key={y} size="sm" variant={filterYear === y ? 'default' : 'outline'} onClick={() => setFilterYear(y)} className={filterYear === y ? 'bg-[#238A92] text-white' : ''}>
                  {y}
                </Button>
              ))}
            </div>
          </div>
          
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
            {filteredEvents.map((event, i) => (
              <Card key={event.title + event.date} className="overflow-hidden group hover:shadow-[var(--shadow-md)] transition-shadow duration-200">
                <div className="aspect-square overflow-hidden bg-[hsl(var(--muted))]">
                  <img
                    src={event.image}
                    alt={event.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                    loading="lazy"
                    onError={e => { e.target.style.display = 'none'; }}
                  />
                </div>
                <CardContent className="p-3">
                  <h3 className="font-semibold text-sm text-[#1F2A37] truncate" style={{fontFamily:'Space Grotesk'}}>{event.title}</h3>
                  <p className="text-xs text-[#238A92]">{event.date}</p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
